import commonPostTypeConfig from '../../common/postTypes/referenceLetter'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'referenceLetter',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
